var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup19574(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.616,
    height: 95.353,
    viewBox: "0 0 107.616 95.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19574",
    "data-name": "Group 19574",
    transform: "translate(-91 -114.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26668",
    "data-name": "Path 26668",
    d: "M91,179.509c.626-2.944,2.575-4.822,4.954-6.474A65.224,65.224,0,0,1,127.48,161.4a67.146,67.146,0,0,1,17.783.671c.134.023.264.065.532.131a31.087,31.087,0,0,0-.934,16.3c-1.124-.188-2.133-.373-3.147-.523-13.467-2-25.8.824-36.883,8.783-2,1.438-4.069,2.47-6.6,2.092a8.38,8.38,0,0,1-7.022-6.365,2.926,2.926,0,0,0-.2-.458Z",
    transform: "translate(0 -33.505)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26669",
    "data-name": "Path 26669",
    d: "M326.843,162.646a24.068,24.068,0,1,1,24.129-23.964A24.031,24.031,0,0,1,326.843,162.646Zm4.43-24.044c1.16-1.129,2.2-2.115,3.212-3.135a3.156,3.156,0,0,0,.189-4.669c-1.324-1.308-3.2-1.222-4.668.244-1.015,1.011-2,2.055-3.09,3.187-1.1-1.136-2.086-2.18-3.1-3.187-1.482-1.467-3.349-1.552-4.67-.246-1.345,1.331-1.255,3.235.263,4.739,1.009,1,2.063,1.954,3.2,3.025-1.092,1.047-2.013,1.9-2.906,2.79-1.79,1.775-1.988,3.639-.557,5.04,1.4,1.376,3.287,1.15,5.049-.63.886-.895,1.741-1.82,2.586-2.706a2.323,2.323,0,0,1,.3.186c.97.961,1.934,1.928,2.907,2.886a3.224,3.224,0,0,0,4.679.27c1.347-1.315,1.261-3.234-.244-4.746C333.436,140.661,332.414,139.7,331.273,138.6Z",
    transform: "translate(-152.357 0)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26670",
    "data-name": "Path 26670",
    d: "M195.849,299.081a8.946,8.946,0,0,1-4.477-1.362,24.93,24.93,0,0,0-25.131.085,8.174,8.174,0,0,1-6.056,1.058,8.366,8.366,0,0,1-6.4-6.755,7.98,7.98,0,0,1,3.984-8.169,40.225,40.225,0,0,1,18.149-5.72,40.744,40.744,0,0,1,24.039,5.691,8,8,0,0,1,3.985,8.368,8.424,8.424,0,0,1-6.33,6.574C197.037,298.982,196.437,299.007,195.849,299.081Z",
    transform: "translate(-45.084 -117.664)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26671",
    "data-name": "Path 26671",
    d: "M230.706,404.073a8.134,8.134,0,1,1-8.142-8.156A8.163,8.163,0,0,1,230.706,404.073Z",
    transform: "translate(-88.777 -202.387)",
    fill: "#e53935"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19574);
export default __webpack_public_path__ + "static/media/Group-19574.a5ca9fad3bd98d7a839a4e6d345c30f6.svg";
export { ForwardRef as ReactComponent };